import React from 'react'

const GradingScale = () => {
    return (
        <div>
            <div className='ms-2 mb-2'>Grading Scale (* Pass/Fail Criteria: 70% or higher *C: Completed)</div>
            <table className='table table-sm table-bordered w-full text-center align-middle'>
                <colgroup>
                    <col width={'10%'}></col>
                    <col width={'10%'}></col>
                    <col width={'10%'}></col>
                    <col width={'10%'}></col>
                    <col width={'10%'}></col>
                    <col width={'10%'}></col>
                    <col width={'10%'}></col>
                    <col width={'10%'}></col>
                    <col width={'10%'}></col>
                    <col width={'10%'}></col>
                </colgroup>
                <tbody>
                    <tr>
                        <td>A+</td>
                        <td>A</td>
                        <td>B+</td>
                        <td>B</td>
                        <td>C+</td>
                        <td>C</td>
                        <td>D+</td>
                        <td>D</td>
                        <td>E</td>
                        <td>P</td>
                    </tr>
                    <tr>
                        <td>95-100</td>
                        <td>90-94</td>
                        <td>85-89</td>
                        <td>80-84</td>
                        <td>75-79</td>
                        <td>70-74</td>
                        <td>65-69</td>
                        <td>60-64</td>
                        <td>59 & Below</td>
                        <td>Pass</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default GradingScale